// extracted by mini-css-extract-plugin
export default {"main":"style_main__8m2p+","head":"style_head__Z93WU","head_devider":"style_head_devider__GGJtb","head_title":"style_head_title__1mHHn","title":"style_title__4DW0D"};